// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.remove-icon-button {
  width: 30px; height: 30px; position: relative;
}
.remove-icon {
  position: absolute;
  font-size: 20px;
  left: 5px; top: 5px;
}
.container {
  display: flex;
  margin: 13px 8px;
  padding: 8px;
  border: 1px solid gray;
  border-radius: 8px;
  background: white;
  opacity: 0.85 !important;
}
.content {
  margin: 0 10px;
  display: flex; flex-grow: 1; flex-direction: column;
}
.label {
  
}
.name {
  color: dimgray; font-size: 12px;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/farmer-building/farmer-building-list.ts"],"names":[],"mappings":";;AAEA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;AAC/C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS,EAAE,QAAQ;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,aAAa,EAAE,YAAY,EAAE,sBAAsB;AACrD;AACA;;AAEA;AACA;EACE,cAAc,EAAE,eAAe;AACjC","sourcesContent":["\n\n.remove-icon-button {\n  width: 30px; height: 30px; position: relative;\n}\n.remove-icon {\n  position: absolute;\n  font-size: 20px;\n  left: 5px; top: 5px;\n}\n.container {\n  display: flex;\n  margin: 13px 8px;\n  padding: 8px;\n  border: 1px solid gray;\n  border-radius: 8px;\n  background: white;\n  opacity: 0.85 !important;\n}\n.content {\n  margin: 0 10px;\n  display: flex; flex-grow: 1; flex-direction: column;\n}\n.label {\n  \n}\n.name {\n  color: dimgray; font-size: 12px;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
